import { render, staticRenderFns } from "./CustomerAddressPanel.vue?vue&type=template&id=7f97f1b9&scoped=true&"
import script from "./CustomerAddressPanel.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f97f1b9",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VForm,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/forge/demo.ec-direct.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f97f1b9')) {
      api.createRecord('7f97f1b9', component.options)
    } else {
      api.reload('7f97f1b9', component.options)
    }
    module.hot.accept("./CustomerAddressPanel.vue?vue&type=template&id=7f97f1b9&scoped=true&", function () {
      api.rerender('7f97f1b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/components/scheduled/CustomerAddressPanel.vue"
export default component.exports